import { paramStringifyQuery } from 'helpers/location';

export default paramStringifyQuery({
  arrayFormat: 'repeat',
});
